(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-chart-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const container = document.querySelector('.size-chart-popup');
  if (!container) return;

  const unit_tog = container.querySelector('.size-chart__unit-toggle input');
  const size_table = container.querySelector('table.size-chart__table');
  if (!unit_tog || !size_table) return;

  unit_tog.addEventListener('change', event => {
    event.stopPropagation();
    size_table.dataset.unit = event.target.checked ? 'cm' : 'inch';
  })
})();
  } catch(e) { console.error(e); }
})();

})();
